import { FeatureCategories } from 'src/modules/designStudio/constants';

export interface MacheteData {
  geometry: object;
  metadata: object;
}
export interface ProductEntry {
  id: number;
  [key: number]: any;
}

export interface TextureMap {
  [id: number]: ProductEntry;
}

export type Color = string | null;
export type TextureId = number | null;
export type GridType = string | null;
export type FrameType = string | null;

export interface WallStyle {
  color: Color;
  textureId: TextureId;
}

export interface RoofStyle {
  textureId: TextureId;
  color: Color;
}

export interface TrimStyle {
  color: Color;
  textureId: TextureId;
}

export enum WindowParametricProperties {
  COLOR = 'color',
  GRID_TYPE = 'gridType',
  FRAME_TYPE = 'frameType',
}

export interface WindowStyle {
  [WindowParametricProperties.COLOR]: Color;
  [WindowParametricProperties.GRID_TYPE]: GridType;
  [WindowParametricProperties.FRAME_TYPE]: FrameType;
}

export interface DesignConfig {
  [FeatureCategories.ROOF]: RoofStyle;
  [FeatureCategories.TRIM]: TrimStyle;
  [FeatureCategories.WALL]: WallStyle;
  [FeatureCategories.WINDOW]: WindowStyle;
}
